import React, { Fragment } from 'react'
import AppHeader from './components/AppHeader'
import AppMain from './components/AppMain'
import AppFooter from './components/AppFooter'
import AppMainBanner from './components/AppMainBanner'
import AppCallToAction from './components/AppCallToAction'

import {
  REGISTER_PATH,
  APPLY_PROJECT_PATH,
  APPLY_ORGANIZATION_PATH,
  APPLY_DOCUMMENTS_PATH
} from '../MainRoutes/constants'
import { Route } from 'react-router-dom'
import MainWrapper from '../../components/MainWrapper'
import ContentWrapper from '../../components/ContentWrapper'
import MainStepper from '../MainStepper'
import MainRoutes from '../MainRoutes'

function App() {
  return (
    <Fragment>
      <AppHeader />
      <AppMain>
        <AppMainBanner />
        <MainWrapper>
          <Route
            path={[
              REGISTER_PATH,
              APPLY_PROJECT_PATH,
              APPLY_ORGANIZATION_PATH,
              APPLY_DOCUMMENTS_PATH
            ]}
            component={MainStepper}
          />
          <ContentWrapper>
            <MainRoutes />
          </ContentWrapper>
          <AppCallToAction />
        </MainWrapper>
      </AppMain>
      <AppFooter />
    </Fragment>
  )
}

export default App
